import { createStore } from "vuex";
import { APIAccount } from "./api";
import router from '../router'

export default createStore ({
    state: {
        access: '',
        refresh: '',
        isAuthenticated: false,
        user: { 
            id: undefined,
            is_superuser: false,
            is_staff: false,
            email: '',
            last_name: '',
            first_name: '',
            fullname: '',
            gender: null,
            gender_value: '',
            entity: null,
            entity_id: null,
            job: null,
            job_id: null,
            is_chief: false,
            is_general_manager: false,
            phone: null,
            photo: null,
            signature: null,
            pages_autocomplete: 0,
            pages_list: 0,
            permissions: []
        },

        notification: 0,
        message: '',
    },
    getters: {
        user: (state) => {
          return state.user;
        },
    },
    
    mutations: {
        initializeStore(state) {
            if (localStorage.getItem('access')) {
                state.access = localStorage.getItem('access')
                state.refresh = localStorage.getItem('refresh')
            } else {
                state.access = ''
                state.refresh = ''
                state.isAuthenticated = false
            }
        },

        setAccess(state, access) {
            state.access = access
        },

        setRefresh(state, refresh) {
            state.refresh = refresh
        },

        setAuthentication(state, authenticated) {
            state.isAuthenticated = authenticated
        },

        setUser(state, newUser) {   
            state.user.id = newUser.id
            state.user.email= newUser.email
            state.user.is_superuser = newUser.is_superuser
            state.user.is_staff = newUser.is_staff
            state.user.last_name = newUser.last_name
            state.user.first_name = newUser.first_name
            state.user.fullname = newUser.fullname
            state.user.gender = newUser.gender
            state.user.gender_value = newUser.gender_value,
            state.user.entity = newUser.entity
            state.user.entity_id = newUser.entity_id
            state.user.job = newUser.job
            state.user.job_id = newUser.job_id
            state.user.phone = newUser.phone
            state.user.photo = newUser.photo
            state.user.signature = newUser.signature
            state.user.pages_autocomplete = newUser.pages_autocomplete
            state.user.pages_list = newUser.pages_list
            state.user.is_chief = newUser.is_chief
            state.user.is_general_manager = newUser.is_general_manager
            state.user.permissions = newUser.permissions
        },

        setMessage(state, message) {
            state.message = message
        },

        setNotification(state, notification) {
            state.notification = notification
        },
    },
    actions: {
        async login ({ commit, dispatch }, loginInfo) {
            try {
                const response = await APIAccount.post("/auth/token/", loginInfo)

                localStorage.setItem("access", response.data.access);
                localStorage.setItem("refresh", response.data.refresh);

                commit("setAccess", response.data.access);
                commit("setRefresh", response.data.refresh);
                commit("setAuthentication", true);
                commit("setMessage", '');
                commit("setNotification", 4);
                
                APIAccount.defaults.headers.common["Authorization"] = `Bearer ${response.data.access}`;

                dispatch('getUser')

                if (router.isReady() && router.currentRoute.value.path === '/login') {
                    router.push('/')
                }
            } catch (error) {
                localStorage.removeItem("access");
                localStorage.removeItem("refresh");

                commit("setAccess", '');
                commit("setRefresh", '');
                commit("setAuthentication", false);
                commit("setMessage", 'Erreur de connexion, vérifiez le login et le mot de passe');
                commit("setNotification", 5);

                APIAccount.defaults.headers.common["Authorization"] = ''

                return
            }
        },

        logout ({ commit }) {
            localStorage.removeItem('access')
            localStorage.removeItem('refresh')

            commit("setAccess", '')
            commit("setRefresh", '')
            commit("setAuthentication", false)
            commit("setUser", {})
            commit("setMessage", '')
            commit("setNotification", 0);

            APIAccount.defaults.headers.common["Authorization"] = ''

            router.push("/login");
        },

        getUser({commit}) {
            APIAccount.get('/me/').then(response => {
                commit('setUser', {
                    id: response.data.id,
                    is_superuser: response.data.is_superuser,
                    is_staff: response.data.is_staff,
                    email: response.data.email,
                    last_name: response.data.last_name,
                    first_name: response.data.first_name,
                    fullname: response.data.fullname,
                    gender: response.data.gender,
                    gender_value: response.data.gender_value,
                    entity: response.data.entity,
                    entity_id: response.data.entity_id,
                    job: response.data.job,
                    job_id: response.data.job_id,
                    is_chief: response.data.is_chief,
                    is_general_manager: response.data.is_general_manager,
                    phone: response.data.phone,
                    photo: response.data.photo?.toString().includes('http') ? response.data.photo : 'user.png',
                    signature: response.data.signature?.toString().includes('http') ? response.data.signature : '',
                    pages_autocomplete: response.data.pages_autocomplete,
                    pages_list: response.data.pages_list,
                    permissions: response.data.permissions,
                })
                console.log(response.data.permissions);


            }).catch(error => {
                commit('setUser', null)
            })
        },

        refreshToken({commit}) {
            const token = localStorage.getItem("refresh")

            if (token != "undefined" && token != null) {
                const data = {
                    "refresh": token
                }
                APIAccount.post('/auth/refresh/', data)
                .then(response => {
                    commit("setAccess", response.data.access)
                    commit("setRefresh", token)
                    
                    localStorage.setItem("access", response.data.access);
                    localStorage.setItem("refresh", token);
                })
                .catch(error => {
                   console.log(`Token refresh error, raison: ${error.message}`); 
                })
            }
        }
    },
})